/* eslint-disable */

import { toCurrency } from '../../utils/CurrencyUtil'
import env from '../../env/env'
import { get, patch } from '../../http/restservice'
import { useEffect, useMemo, useState } from 'react'
import { Separator } from '../../Components/ui/separator'
import { ArrowDown, ArrowUp, EllipsisVertical, Loader2, MoveRight, Plus } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '../../Components/ui/card'
import {
  ArrowCircleDownOutlined,
  ArrowCircleUpOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Refresh,
} from '@mui/icons-material'
import { Button } from '../../Components/ui/button'
import { Link, useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import IconsSelector from '../../store/IconsStore'
import { FinancialGoalsReversed } from '../../utils/Util'
import NoInvestments from '../../assets/images/nodata.svg'
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from '../../Components/ui/menubar'
import { Checkbox } from '../../Components/ui/checkbox'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../Components/ui/table'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../Components/ui/dialog'
import { Label } from '../../Components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../Components/ui/select'
import { toast } from 'sonner'
import { Spinner } from '../../Components/ui/spinner'

const UserBasketHoldings = ({ clientCode }) => {
  const navigate = useNavigate()
  const [orders, setOrders] = useState([])
  const [nonMappedOrders, setNonMappedOrders] = useState([])
  const [selectedNonMappedOrders, setSelectedNonMappedOrders] = useState([])
  const [mapModalOpen, setMapModalOpen] = useState(false)
  const [selectedBasketInvestmentId, setSelectedBasketInvestmentId] = useState('')
  const [mapSubmitting, setMapSubmitting] = useState(false)
  const [shuffleModalOpen, setShuffleModalOpen] = useState(false)
  const [shuffleSubmitting, setShuffleSubmitting] = useState(false)
  const [selectedShuffleBasketInvestmentId, setSelectedShuffleBasketInvestmentId] = useState('')
  const [selectedShuffleFund, setSelectedShuffleFund] = useState(null)
  const [holdingsLoading, setHoldingsLoading] = useState(true)
  const [nonMappedLoading, setNonMappedLoading] = useState(true)

  const fetchNonMappedOrders = async () => {
    setNonMappedLoading(true)
    try {
      const res = await get(
        `${env.API_URL}mutualfundservice/api/mutualFund/nonMappedOrderHistory?userId=${clientCode}`,
      )


      const mappedOrders = Array.isArray(res)
        ? res
        : Array.isArray(res?.orders)
          ? res.orders
          : Array.isArray(res?.data)
            ? res.data
            : []

      setNonMappedOrders(mappedOrders)
    } catch (error) {
      console.log(error)
    } finally {
      setNonMappedLoading(false)
    }
  }

  const fetchUserBasketHoldings = async () => {
    setHoldingsLoading(true)
    try {
      const res = await get(
        `${env.API_URL}adminservice/api/actionPlan/fetchCustomerBasketHoldings?clientCode=${clientCode}`,
      )
      let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
      setOrders(data)
    } catch (error) {
      console.log(error)
    } finally {
      setHoldingsLoading(false)
    }
  }

  useEffect(() => {
    fetchUserBasketHoldings()
    fetchNonMappedOrders()
  }, [clientCode])


  const [groupedOrders, setGroupedOrders] = useState({})
  const [expandedIndex, setExpandedIndex] = useState(null)
  const iconsList = useRecoilValue(IconsSelector)

  const groupByBasketId = (orders) =>
    orders.reduce((acc, { customerBasketInvestmentId, basketStatus, ...order }) => {
      if (!acc[customerBasketInvestmentId]) {
        acc[customerBasketInvestmentId] = []
      }
      acc[customerBasketInvestmentId].push({ basketStatus, customerBasketInvestmentId, ...order })

      return acc
    }, {})

  useEffect(() => {
    if (orders?.holdings?.length > 0) {
      setGroupedOrders(groupByBasketId(orders.holdings))
    } else {
      console.error('Error fetching orders:', orders)
    }
  }, [orders])

  const getTotalAmount = () => {
    return orders.holdings.reduce((acc, order) => {
      return acc + Number(order.currentNav * order.netUnits)
    }, 0)
  }

  const getTotalInvestedAmount = () => {
    return orders.holdings.reduce((acc, order) => {
      return acc + Number(order.netInvestedAmount)
    }, 0)
  }

  const getBasketCurrentAmount = (basketOrders) => {
    return basketOrders.reduce((acc, order) => {
      return acc + Number(order.currentNav * order.netUnits)
    }, 0)
  }

  const getBasketInvestedAmount = (basketOrders) => {
    return basketOrders.reduce((acc, order) => {
      return acc + Number(order.netInvestedAmount)
    }, 0)
  }

  function truncateToTwoDecimals(num) {
    return Math.trunc(num * 100) / 100
  }

  const calculateParcentage = (invested, returns) => {
    const result = ((returns - invested) / invested) * 100
    return truncateToTwoDecimals(result)
  }

  const getReturns = () => {
    const total = getTotalAmount()
    const invested = getTotalInvestedAmount()

    // Calculate returns in percentage
    const returns = ((total - invested) / invested) * 100

    return returns < 0 ? toCurrency(returns) : toCurrency(returns)
  }

  const basketOptions = {
    1: '6+ Retirement',
    2: '3-6 Education',
    3: '3-6 Wedding',
    4: '1-3',
    5: '1',
    6: 'Emergency',
    8: 'Commodities',
    10: 'Anytime',
  }

  const handleNavigate = (basketOrders) => {
    navigate(
      '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/basket/investmore',
      {
        state: {
          basket: basketOrders,
          clientCode: clientCode,
        },
      },
    )
  }

  const AddSIP = (basketOrders) => {
    navigate(
      '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/basket/add-sip',
      {
        state: {
          basket: basketOrders,
          clientCode: clientCode,
        },
      },
    )
  }

  const handleRedeem = (basketOrders) => {
    navigate(
      '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/basket/redeem',
      {
        state: {
          basket: basketOrders,
          clientCode: clientCode,
        },
      },
    )
  }

  const getNonMappedOrderKey = (order, index) =>
    `${order?.orderNumber || 'order'}-${order?.bseSchemeCode || 'scheme'}-${index}`

  const allNonMappedSelected =
    nonMappedOrders?.length > 0 && selectedNonMappedOrders.length === nonMappedOrders.length

  const handleSelectAllNonMapped = (checked) => {
    if (checked) {
      setSelectedNonMappedOrders(nonMappedOrders.map((order, index) => getNonMappedOrderKey(order, index)))
      return
    }
    setSelectedNonMappedOrders([])
  }

  const handleSelectNonMappedOrder = (orderKey, checked) => {
    if (checked) {
      setSelectedNonMappedOrders((prev) => (prev.includes(orderKey) ? prev : [...prev, orderKey]))
      return
    }
    setSelectedNonMappedOrders((prev) => prev.filter((item) => item !== orderKey))
  }

  const basketSelectOptions = useMemo(() => {
    if (!orders?.holdings?.length) return []
    const byId = new Map()
    orders.holdings.forEach((h) => {
      const id = h?.customerBasketInvestmentId
      if (id == null || byId.has(id)) return
      byId.set(id, {
        customerBasketInvestmentId: id,
        customerBasketName: h?.customerBasketName || `Basket ${id}`,
      })
    })
    return Array.from(byId.values())
  }, [orders])

  const selectedBasketHoldings = useMemo(() => {
    if (!selectedBasketInvestmentId || !orders?.holdings?.length) return []
    const id = String(selectedBasketInvestmentId)
    return orders.holdings.filter((h) => String(h?.customerBasketInvestmentId) === id)
  }, [orders, selectedBasketInvestmentId])

  const selectedBasketName = useMemo(() => {
    const match = basketSelectOptions.find(
      (b) => String(b.customerBasketInvestmentId) === String(selectedBasketInvestmentId),
    )
    return match?.customerBasketName || ''
  }, [basketSelectOptions, selectedBasketInvestmentId])

  const shuffleBasketOptions = useMemo(() => {
    if (!selectedShuffleFund?.customerBasketInvestmentId) return basketSelectOptions
    return basketSelectOptions.filter(
      (b) =>
        String(b.customerBasketInvestmentId) !==
        String(selectedShuffleFund.customerBasketInvestmentId),
    )
  }, [basketSelectOptions, selectedShuffleFund])

  const selectedShuffleBasketHoldings = useMemo(() => {
    if (!selectedShuffleBasketInvestmentId || !orders?.holdings?.length) return []
    const id = String(selectedShuffleBasketInvestmentId)
    return orders.holdings.filter((h) => String(h?.customerBasketInvestmentId) === id)
  }, [orders, selectedShuffleBasketInvestmentId])

  const selectedShuffleBasketName = useMemo(() => {
    const match = basketSelectOptions.find(
      (b) => String(b.customerBasketInvestmentId) === String(selectedShuffleBasketInvestmentId),
    )
    return match?.customerBasketName || ''
  }, [basketSelectOptions, selectedShuffleBasketInvestmentId])

  const getSelectedNonMappedOrderObjects = () =>
    nonMappedOrders.filter((order, index) =>
      selectedNonMappedOrders.includes(getNonMappedOrderKey(order, index)),
    )

  const closeMapModal = () => {
    if (mapSubmitting) return
    setMapModalOpen(false)
    setSelectedBasketInvestmentId('')
  }

  const openShuffleModal = (fund) => {
    setSelectedShuffleFund(fund)
    setSelectedShuffleBasketInvestmentId('')
    setShuffleModalOpen(true)
  }

  const closeShuffleModal = () => {
    if (shuffleSubmitting) return
    setShuffleModalOpen(false)
    setSelectedShuffleBasketInvestmentId('')
    setSelectedShuffleFund(null)
  }

  const handleAssignOrdersToBasket = async () => {
    if (!selectedBasketInvestmentId) {
      toast.error('Please select a basket')
      return
    }
    const selectedOrders = getSelectedNonMappedOrderObjects()
    const orderNumbers = selectedOrders
      .map((o) => (o?.orderNumber != null ? String(o.orderNumber) : ''))
      .filter(Boolean)
    if (!orderNumbers.length) {
      toast.error('No valid order numbers in selection')
      return
    }

    setMapSubmitting(true)

    try {
      const res = await patch(`${env.API_URL}mutualfundservice/api/mutualFund/assignOrdersToBasket`, {
        orderNumbers,
        customerBasketInvestmentId: Number(selectedBasketInvestmentId),
      })

      if (res?.isError) {
        const msg =
          res?.response?.message ||
          res?.response?.error ||
          (typeof res?.response === 'string' ? res.response : null) ||
          'Failed to map orders'
        toast.error(msg)
        return
      }

      if (res?.status === 'FAILURE' || res?.code === '400' || res?.success === false) {
        toast.error(res?.message || res?.msg || 'Failed to map orders')
        return
      }

      toast.success('Orders mapped successfully')
      setMapModalOpen(false)
      setSelectedBasketInvestmentId('')
      setSelectedNonMappedOrders([])
      await fetchNonMappedOrders()
      await fetchUserBasketHoldings()
    } catch (e) {
      toast.error(e?.message || 'Something went wrong')
    } finally {
      setMapSubmitting(false)
    }
  }

  const handleShuffleFund = async () => {


    if (!selectedShuffleFund?.bseSchemeCode) {
      toast.error('Scheme code is missing for selected fund')
      return
    }
    if (!selectedShuffleFund?.customerBasketInvestmentId) {
      toast.error('Current basket is missing for selected fund')
      return
    }
    if (!selectedShuffleBasketInvestmentId) {
      toast.error('Please select a new basket')
      return
    }

    setShuffleSubmitting(true)

    try {
      const res = await patch(
        `${env.API_URL}mutualfundservice/api/basket/assignSchemeToDifferentBasket`,
        {
          schemeCode: selectedShuffleFund.bseSchemeCode,
          customerBasketInvestmentId: Number(selectedShuffleFund.customerBasketInvestmentId),
          newCustomerBasketInvestmentId: Number(selectedShuffleBasketInvestmentId),
        },
      )

      if (res?.isError) {
        const msg =
          res?.response?.message ||
          res?.response?.error ||
          (typeof res?.response === 'string' ? res.response : null) ||
          'Failed to move fund'
        toast.error(msg)
        return
      }

      if (res?.status === 'FAILURE' || res?.code === '400' || res?.success === false) {
        toast.error(res?.message || res?.msg || 'Failed to move fund')
        return
      }

      toast.success('Fund moved successfully')
      closeShuffleModal()
      await fetchUserBasketHoldings()
    } catch (error) {
      toast.error(error?.message || 'Something went wrong')
    } finally {
      setShuffleSubmitting(false)
    }
  }



  return (
    <div className={`py-2 ${selectedNonMappedOrders.length > 0 ? 'pb-24' : ''}`}>



      <div className='mb-6 px-2'>
        {holdingsLoading ? (
          <div className='flex min-h-[140px] flex-col items-center justify-center gap-3 rounded-xl border border-[#D3DBEC] bg-[#F4F7FE]/40 py-10'>
            <Spinner className='h-8 w-8 text-primary-500' />
            <span className='text-sm text-black-400'>Loading basket holdings…</span>
          </div>
        ) : orders?.status === 'SUCCESS' && orders?.holdings?.length > 0 ? (
          <div className='w-full lg:max-w-2xl mx-auto px-6 py-4 rounded-xl md:rounded-3xl border text-nowrap bg-[#F4F7FE]'>
            <div className='flex justify-between items-center space-x-6'>
              <div className='space-y-1 flex-1'>
                <p className='font-semibold text-primary-500 text-lg'>
                  ₹{' '}
                  {toCurrency(
                    orders?.holdings?.reduce((sum, item) => sum + item.netInvestedAmount, 0) || 0,
                  )}
                </p>

                <p className='text-sm text-black-400'>Invested</p>
              </div>
              <Separator orientation='vertical' className='h-11' />
              <div className='space-y-1 flex-1'>
                <p className='font-semibold text-primary-500 text-lg'>
                  ₹{' '}
                  {toCurrency(
                    orders?.holdings?.reduce(
                      (sum, item) => sum + item.netUnits * item.currentNav,
                      0,
                    ) || 0,
                  )}
                </p>
                <p className='text-sm text-black-400 flex gap-x-1 items-center'>
                  Current{' '}
                  <span
                    className={`${getReturns(orders) < 0
                      ? 'bg-error-600 text-error-600'
                      : 'bg-secondary-600 text-secondary-600'
                      } font-semibold  rounded-[50%] h-5 w-5 flex justify-center items-center mr-1 sm:hidden`}
                  >
                    {getReturns(orders) < 0 ? (
                      <ArrowDown className='h-4 w-4 text-white' />
                    ) : (
                      <ArrowUp className='h-4 w-4 text-white' />
                    )}
                  </span>
                  <span className='text-secondary-600 font-semibold sm:hidden'>
                    {' '}
                    {getReturns(orders)} %
                  </span>
                </p>
              </div>
              <Separator orientation='vertical' className='h-11 hidden sm:block' />
              <div className='space-y-1 hidden sm:block flex-1'>
                <p className='font-semibold text-lg'>
                  ₹{' '}
                  {toCurrency(
                    (orders?.holdings?.reduce(
                      (sum, item) => sum + item.netUnits * item.currentNav,
                      0,
                    ) || 0) -
                    (orders?.holdings?.reduce((sum, item) => sum + item.netInvestedAmount, 0) ||
                      0),
                  )}
                </p>
                <div className='flex gap-x-1 items-center text-sm text-black-400'>
                  Returns{' '}
                  <p className='font-semibold text-secondary-600 flex items-center'>
                    <span
                      className={`${getReturns(orders) < 0
                        ? 'bg-error-600 text-error-600'
                        : 'bg-secondary-600 text-secondary-600'
                        } rounded-[50%] h-5 w-5 flex justify-center items-center text-white mr-1`}
                    >
                      {getReturns(orders) < 0 ? (
                        <ArrowDown className='h-4 w-4 text-white' />
                      ) : (
                        <ArrowUp className='h-4 w-4 text-white' />
                      )}
                    </span>
                    <span
                      className={`${getReturns(orders) < 0 ? 'text-error-600' : 'text-secondary-600'
                        } `}
                    >
                      {getReturns(orders)} %
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p className='rounded-xl border border-[#D3DBEC] bg-white px-4 py-8 text-center text-sm text-black-400'>
            No basket holdings found for this client.
          </p>
        )}
      </div>

      <div className='bg-white px-10'>
        {holdingsLoading ? (
          <div className='flex flex-col items-center justify-center gap-2 py-12'>
            <Spinner className='h-8 w-8 text-primary-500' />
            <span className='text-sm text-black-400'>Loading basket holdings…</span>
          </div>
        ) : (
          <>
            {orders?.status === 'SUCCESS' && orders?.holdings?.length > 0 && (
              <>
                <div className='lg:mx-auto overflow-hidden'>
                  <div className='hidden md:flex justify-between py-3 pl-14 pr-2 bg-[#F4F7FE] text-primary-400 leading-5 text-sm rounded-xl'>
                    <div>Plan Name</div>

                    <div className='flex'>
                      <div className='w-[150px] text-right pr-3'>Invested</div>
                      <div className='w-[150px] text-right pr-3'>Current</div>
                      <div className='w-[150px] text-right pr-3'>Returns</div>
                    </div>
                  </div>

                  {orders?.holdings?.length > 0 ? (
                    Object.entries(groupedOrders).map(([key, basketOrders], index) => {
                      return (
                        <div key={key} className='cursor-pointer w-full'>
                          <div className='py-2 text-sm font-medium text-black-400 mb-4 mt-2 leading-5 px-4 lg:px-0'>
                            <div
                              className='flex justify-between items-center w-full'
                              onClick={() => {
                                setExpandedIndex((prevIndex) => (prevIndex === index ? null : index))
                              }}
                            >
                              <div className='w-full md:w-auto'>
                                <div className='flex md:justify-between items-start md:items-center gap-x-2'>
                                  <img
                                    src={
                                      iconsList[
                                        'light' + FinancialGoalsReversed[basketOrders[0]?.planType]
                                      ]
                                        ? iconsList[
                                        'light' + FinancialGoalsReversed[basketOrders[0]?.planType]
                                        ]
                                        : `${env.SVGS}/basket.svg`
                                    }
                                    className='h-12 w-12 rounded-[8px] mt-1'
                                  />

                                  <div className='w-full'>
                                    <div className='flex justify-between gap-x-4 items-center'>
                                      <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                        {basketOrders[0]?.customerBasketName}
                                      </p>

                                      <div className='flex gap-x-2 items-center'>
                                        <span className='flex-shrink-0 text-black-200 md:hidden'>
                                          <KeyboardArrowDown sx={{ fontSize: '24px' }} />
                                        </span>

                                        <Menubar className='lg:hidden'>
                                          <MenubarMenu className='bg-transparent lg:hidden'>
                                            <MenubarTrigger className=' p-1 h-6 w-6 rounded-full hover:bg-[#D3DBEC]'>
                                              <EllipsisVertical
                                                fill='#5D5D5D'
                                                className='cursor-pointer hover:text-primary-500'
                                              />
                                            </MenubarTrigger>

                                            <MenubarContent className='rounded-[10px] flex flex-col gap-y-1'>
                                              <MenubarItem
                                                className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                                onClick={() => handleNavigate(basketOrders)}
                                              >
                                                Invest More
                                              </MenubarItem>

                                              <MenubarItem
                                                className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                                onClick={() => AddSIP(basketOrders)}
                                              >
                                                Add SIP
                                              </MenubarItem>

                                              {/* <MenubarItem
                                      className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                      onClick={() => handleRedeem(basketOrders)}
                                    >
                                      Redeem
                                    </MenubarItem> */}
                                            </MenubarContent>
                                          </MenubarMenu>
                                        </Menubar>
                                      </div>
                                    </div>

                                    <div className='flex md:hidden gap-x-1 items-center'>
                                      {calculateParcentage(
                                        getBasketInvestedAmount(basketOrders),
                                        getBasketCurrentAmount(basketOrders),
                                      ) != 0 && (
                                          <span>
                                            {calculateParcentage(
                                              getBasketInvestedAmount(basketOrders),
                                              getBasketCurrentAmount(basketOrders),
                                            ) > 0 ? (
                                              <ArrowCircleUpOutlined
                                                style={{ height: '16px', width: '16px' }}
                                                className='text-secondary-600'
                                              />
                                            ) : (
                                              <ArrowCircleDownOutlined
                                                style={{ height: '16px', width: '16px' }}
                                                className='text-error-600'
                                              />
                                            )}
                                          </span>
                                        )}

                                      <p
                                        className={`font-semibold leading-6 ${calculateParcentage(
                                          getBasketInvestedAmount(basketOrders),
                                          getBasketCurrentAmount(basketOrders),
                                        ) > 0
                                          ? 'text-secondary-600'
                                          : calculateParcentage(
                                            getBasketInvestedAmount(basketOrders),
                                            getBasketCurrentAmount(basketOrders),
                                          ) < 0
                                            ? 'text-error-600'
                                            : 'text-black-500'
                                          }`}
                                      >
                                        {calculateParcentage(
                                          getBasketInvestedAmount(basketOrders),
                                          getBasketCurrentAmount(basketOrders),
                                        )}{' '}
                                        %
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className='mt-4 px-2 text-xs flex md:hidden justify-between items-center text-nowrap gap-x-4'>
                                  <div>
                                    <p className='font-semibold leading-6 text-black-500'>
                                      ₹ {toCurrency(getBasketInvestedAmount(basketOrders))}
                                    </p>
                                    <p className='text-black-400'>Invested</p>
                                  </div>
                                  <div>
                                    <p className='font-semibold leading-6 text-black-500'>
                                      ₹ {toCurrency(getBasketCurrentAmount(basketOrders))}
                                    </p>
                                    <p className='text-black-400'>Current Value</p>
                                  </div>

                                  <div>
                                    <p
                                      className={`font-semibold leading-6 ${getBasketCurrentAmount(basketOrders) -
                                        getBasketInvestedAmount(basketOrders) >
                                        0
                                        ? 'text-secondary-600'
                                        : getBasketCurrentAmount(basketOrders) -
                                          getBasketInvestedAmount(basketOrders) <
                                          0
                                          ? 'text-error-600'
                                          : 'text-black-500'
                                        }`}
                                    >
                                      ₹{' '}
                                      {toCurrency(
                                        getBasketCurrentAmount(basketOrders) -
                                        getBasketInvestedAmount(basketOrders),
                                      )}
                                    </p>
                                    <p className='text-black-400'>Gain/Loss</p>
                                  </div>
                                </div>
                              </div>

                              <div className='hidden md:flex items-center gap-x-4'>
                                <div className='flex justify-end items-center gap-x-1 min-w-[150px]'>
                                  <p className='font-semibold leading-6 text-black-500'>
                                    ₹ {toCurrency(getBasketInvestedAmount(basketOrders))}
                                  </p>
                                </div>

                                <div className='flex justify-end items-center gap-x-1 min-w-[150px]'>
                                  <p className='font-semibold leading-6 text-black-500'>
                                    ₹ {toCurrency(getBasketCurrentAmount(basketOrders))}
                                  </p>
                                </div>

                                <div className='flex justify-end items-center gap-x-1 min-w-[150px]'>
                                  <p
                                    className={`font-semibold leading-6  ${calculateParcentage(
                                      getBasketInvestedAmount(basketOrders),
                                      getBasketCurrentAmount(basketOrders),
                                    ) > 0
                                      ? 'text-secondary-600'
                                      : calculateParcentage(
                                        getBasketInvestedAmount(basketOrders),
                                        getBasketCurrentAmount(basketOrders),
                                      ) < 0
                                        ? 'text-error-600'
                                        : 'text-black-500'
                                      }`}
                                  >
                                    {calculateParcentage(
                                      getBasketInvestedAmount(basketOrders),
                                      getBasketCurrentAmount(basketOrders),
                                    )}{' '}
                                    %
                                  </p>
                                  {expandedIndex === null ? (
                                    <KeyboardArrowDown
                                      className='flex-shrink-0 text-black-200'
                                      sx={{ fontSize: '24px' }}
                                    />
                                  ) : (
                                    <KeyboardArrowUp
                                      className='flex-shrink-0 text-black-200'
                                      sx={{ fontSize: '24px' }}
                                    />
                                  )}

                                  <Menubar>
                                    <MenubarMenu className='bg-transparent'>
                                      <MenubarTrigger className=' p-1 h-6 w-6 rounded-full hover:bg-[#D3DBEC]'>
                                        <EllipsisVertical
                                          fill='#5D5D5D'
                                          className='cursor-pointer hover:text-primary-500'
                                        />
                                      </MenubarTrigger>

                                      <MenubarContent className='rounded-[10px] flex flex-col gap-y-1'>
                                        <MenubarItem
                                          className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                          onClick={() => handleNavigate(basketOrders)}
                                        >
                                          Invest More
                                        </MenubarItem>

                                        <MenubarItem
                                          className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                          onClick={() => AddSIP(basketOrders)}
                                        >
                                          Add SIP
                                        </MenubarItem>

                                        {/* <MenubarItem
                                      className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                      onClick={() => handleRedeem(basketOrders)}
                                    >
                                      Redeem
                                    </MenubarItem> */}
                                      </MenubarContent>
                                    </MenubarMenu>
                                  </Menubar>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`text-sm lg:pl-6 px-2 flex-col justify-between items-start mt-4 text-gray-500 overflow-hidden transition-all duration-300 ease-in-out ${expandedIndex === index
                                ? 'max-h-max opacity-100 pt-4 border-b'
                                : 'max-h-0 opacity-0 border-t'
                                }`}
                            >
                              {basketOrders?.map((order, index) => {
                                return (
                                  <div
                                    className={`py-4 flex items-center lg:items-start w-full`}
                                    key={index}
                                  >
                                    <div className='flex justify-between w-full'>
                                      <div
                                        className='flex justify-between items-center w-full'
                                        onClick={() => {
                                          setExpandedIndex((prevIndex) =>
                                            prevIndex === index ? null : index,
                                          )
                                        }}
                                      >
                                        <div className='w-full md:w-auto'>
                                          <div className='flex justify-between items-start gap-x-2'>
                                            <img
                                              src={`${env.MF_LOGOS_URL}/${order?.amcCode}.png`}
                                              className='h-12 w-12 rounded-[8px]'
                                            />
                                            <div className='w-full md:w-auto'>
                                              <p className='font-semibold text-gray-900 text-wrap md:max-w-full leading-6'>
                                                {order?.legalName
                                                  ? order?.legalName
                                                  : order?.schemeName}
                                              </p>

                                              <div className='flex justify-between md:justify-normal w-full gap-x-5'>
                                                <div className='text-xs md:text-sm flex justify-between md:justify-start gap-x-12 leading-5 flex-shrink-0 text-right w-full'>
                                                  <p className='text-black-400 leading-5 font-medium'>
                                                    NAV : {toCurrency(order.currentNav)}
                                                  </p>

                                                  {order.netUnits && (
                                                    <p className='font-medium text-black-400'>
                                                      {order.netUnits
                                                        ? toCurrency(order.netUnits)
                                                        : null}{' '}
                                                      Units
                                                    </p>
                                                  )}
                                                </div>
                                              </div>

                                              <div className='flex text-xs md:hidden justify-between items-center gap-x-2'>
                                                {order.netInvestedAmount && (
                                                  <p className='font-semibold leading-6 text-black-500'>
                                                    ₹{' '}
                                                    {order.netInvestedAmount
                                                      ? toCurrency(order.netInvestedAmount)
                                                      : null}
                                                  </p>
                                                )}

                                                {order.currentNav && order.netUnits && (
                                                  <p className='flex items-center gap-x-1 font-semibold leading-6 text-black-500'>
                                                    ₹ {toCurrency(order.currentNav * order.netUnits)}
                                                    {calculateParcentage(
                                                      order.netInvestedAmount,
                                                      order.currentNav * order.netUnits,
                                                    ) > 0 ? (
                                                      <ArrowCircleUpOutlined
                                                        style={{ height: '16px', width: '16px' }}
                                                        className='text-secondary-600'
                                                      />
                                                    ) : (
                                                      <ArrowCircleDownOutlined
                                                        style={{ height: '16px', width: '16px' }}
                                                        className='text-error-600'
                                                      />
                                                    )}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className='flex items-center gap-x-1'>
                                          <Button
                                            type='button'
                                            variant='outline'
                                            className='h-8 px-3 text-xs mr-2'
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              openShuffleModal(order)
                                            }}
                                          >
                                            Shuffle
                                          </Button>
                                          <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px] pr-4'>
                                            <p className='font-semibold leading-6 text-black-500'>
                                              ₹ {toCurrency(order.netInvestedAmount)}
                                            </p>
                                          </div>

                                          <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px]'>
                                            <p className='font-semibold leading-6 text-black-500'>
                                              ₹ {toCurrency(order.currentNav * order.netUnits)}
                                            </p>
                                          </div>

                                          <div className='hidden md:flex justify-end items-center gap-x-1 min-w-[150px] pr-4'>
                                            <p
                                              className={`font-semibold leading-6 ${calculateParcentage(
                                                order.netInvestedAmount,
                                                order.currentNav * order.netUnits,
                                              ) > 0
                                                ? 'text-secondary-600'
                                                : calculateParcentage(
                                                  order.netInvestedAmount,
                                                  order.currentNav * order.netUnits,
                                                ) < 0
                                                  ? 'text-error-600'
                                                  : 'text-black-500'
                                                }`}
                                            >
                                              {calculateParcentage(
                                                order.netInvestedAmount,
                                                order.currentNav * order.netUnits,
                                              )}{' '}
                                              %
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <div className='bg-white flex items-center justify-center'>
                      <Card className='w-full max-w-sm text-center border-none shadow-none font-DMSans'>
                        <CardHeader className='flex flex-col gap-y-6 justify-center items-center'>
                          <img
                            className='h-14 w-14'
                            src={`${env.SVGS}/error-icon.svg`}
                            alt='Error-Icon'
                          />
                          <CardTitle className='font-semibold text-base'>
                            Oops! Something Went Wrong
                          </CardTitle>
                        </CardHeader>
                        <CardContent className='flex flex-col gap-y-6'>
                          <p className='text-sm leading-5 text-black-400 mb-6'>
                            We're sorry, but it seems there was an issue connecting to our server.
                            Please check your internet connection or try refreshing the page. If the
                            problem persists, try again later.
                          </p>

                          <div className='flex gap-x-2 justify-between'>
                            <Button
                              className='w-full'
                              variant='fabitsWhite'
                              onClick={() => window.location.reload()}
                            >
                              <Refresh className='mr-2 h-4 w-4 text-black-300' /> Refresh
                            </Button>

                            <Link className='flex-1' to='/dashboard/mutual-funds'>
                              <Button className='w-full'>
                                View Funds
                                <MoveRight className='ml-2 h-4 w-4' />
                              </Button>
                            </Link>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                  )}
                </div>
              </>
            )}

            {(orders?.status === 'SUCCESS' ||
              (orders?.length === 0 && (
                <div className='bg-white flex items-center justify-center'>
                  <Card className='w-full max-w-2xl text-center border-none shadow-none'>
                    <CardHeader>
                      <img className='mx-auto' src={NoInvestments} alt='Error-Icon' />
                      <CardTitle className='text-xl'>You haven’t set any goals yet</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className='text-sm text-black-400 mb-4'>
                        Take the first step towards your financial future by setting up a goal today.
                      </p>
                      <Link to='/dashboard/plans'>
                        <Button className='w-full'>
                          <Plus className='mr-2 h-4 w-4' /> Create Goal
                        </Button>
                      </Link>
                    </CardContent>
                  </Card>
                </div>
              )))}

            {orders?.status === 'FAILURE' && (
              <div className='bg-white flex items-center justify-center'>
                <Card className='w-full max-w-sm text-center border-none shadow-none font-DMSans'>
                  <CardHeader className='flex flex-col gap-y-6 justify-center items-center'>
                    <img className='h-14 w-14' src={`${env.SVGS}/error-icon.svg`} alt='Error-Icon' />
                    <CardTitle className='font-semibold text-base'>
                      Oops! Something Went Wrong
                    </CardTitle>
                  </CardHeader>
                  <CardContent className='flex flex-col gap-y-6'>
                    <p className='text-sm leading-5 text-black-400 mb-6'>
                      We're sorry, but it seems there was an issue connecting to our server. Please
                      check your internet connection or try refreshing the page. If the problem
                      persists, try again later.
                    </p>

                    <div className='flex gap-x-2 justify-between'>
                      <Button
                        className='w-full'
                        variant='fabitsWhite'
                        onClick={() => window.location.reload()}
                      >
                        <Refresh className='mr-2 h-4 w-4 text-black-300' /> Refresh
                      </Button>

                      <Link className='flex-1' to='/dashboard/mutual-funds'>
                        <Button className='w-full'>
                          View Funds
                          <MoveRight className='ml-2 h-4 w-4' />
                        </Button>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>
            )}
          </>
        )}
      </div>

      <div className='mb-6 px-2'>
        <h2 className='text-2xl font-bold'>Non Mapped Orders</h2>

        {nonMappedLoading ? (
          <div className='mt-6 flex flex-col items-center justify-center gap-3 py-12'>
            <Spinner className='h-8 w-8 text-primary-500' />
            <span className='text-sm text-black-400'>Loading non-mapped orders…</span>
          </div>
        ) : nonMappedOrders?.length > 0 ? (
          <div className='mt-4'>

            <div className='hidden md:block'>
              <Table className='border-collapse rounded-lg shadow-lg'>
                <TableHeader className='bg-[#F4F7FE]'>
                  <TableRow className='border-none'>
                    <TableHead className='w-12 rounded-l-xl'>
                      <Checkbox
                        checked={allNonMappedSelected}
                        onCheckedChange={handleSelectAllNonMapped}
                        className='data-[state=checked]:bg-primary-500'
                      />
                    </TableHead>
                    <TableHead className='text-primary-400'>Fund Name</TableHead>
                    <TableHead className='text-primary-400'>Order No.</TableHead>
                    <TableHead className='text-primary-400'>Order Date</TableHead>
                    <TableHead className='text-primary-400'>Status</TableHead>
                    <TableHead className='text-primary-400 text-right'>Allotted Amount</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {nonMappedOrders.map((order, index) => {
                    const orderKey = getNonMappedOrderKey(order, index)
                    return (
                      <TableRow key={orderKey}>
                        <TableCell className='w-12'>
                          <Checkbox
                            checked={selectedNonMappedOrders.includes(orderKey)}
                            onCheckedChange={(checked) =>
                              handleSelectNonMappedOrder(orderKey, checked)
                            }
                            className='data-[state=checked]:bg-primary-500'
                          />
                        </TableCell>
                        <TableCell>
                          <div className='flex items-center gap-2'>
                            <img
                              src={`${env.MF_LOGOS_URL}/${order?.amcCode}.png`}
                              alt={order?.amcCode || 'amc-logo'}
                              className='h-9 w-9 rounded-md'
                            />
                            <p className='font-semibold'>
                              {order?.legalName || order?.schemeName || '-'}
                            </p>
                          </div>
                        </TableCell>
                        <TableCell>{order?.orderNumber || '-'}</TableCell>
                        <TableCell>{order?.orderDate || '-'}</TableCell>
                        <TableCell>{order?.currentStatus || order?.orderStatus || '-'}</TableCell>
                        <TableCell className='text-right font-semibold'>
                          ₹ {toCurrency(Number(order?.allotedAmt || 0))}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </div>

            <div className='md:hidden flex flex-col gap-3 mt-3'>
              {nonMappedOrders.map((order, index) => {
                const orderKey = getNonMappedOrderKey(order, index)
                return (
                  <div key={orderKey} className='rounded-lg border p-3'>
                    <div className='flex items-start gap-3'>
                      <Checkbox
                        checked={selectedNonMappedOrders.includes(orderKey)}
                        onCheckedChange={(checked) => handleSelectNonMappedOrder(orderKey, checked)}
                        className='mt-1 data-[state=checked]:bg-primary-500'
                      />
                      <div className='w-full'>
                        <div className='flex items-center gap-2'>
                          <img
                            src={`${env.MF_LOGOS_URL}/${order?.amcCode}.png`}
                            alt={order?.amcCode || 'amc-logo'}
                            className='h-9 w-9 rounded-md'
                          />
                          <p className='font-semibold text-black-500'>
                            {order?.legalName || order?.schemeName || '-'}
                          </p>
                        </div>
                        <div className='text-xs text-black-400 mt-1 space-y-1'>
                          <p>Order No: {order?.orderNumber || '-'}</p>
                          <p>Date: {order?.orderDate || '-'}</p>
                          <p>Status: {order?.currentStatus || order?.orderStatus || '-'}</p>
                          <p className='font-semibold text-black-500'>
                            Amount: ₹ {toCurrency(Number(order?.allotedAmt || 0))}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : (
          <p className='mt-4 text-sm text-black-400'>No non-mapped orders for this client.</p>
        )}
      </div>

      {selectedNonMappedOrders.length > 0 && (
        <div className='fixed bottom-0 left-0 right-0 z-50 border-t border-[#D3DBEC] bg-white px-4 py-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)]'>
          <div className='mx-auto flex max-w-4xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between'>
            <p className='text-sm text-black-500'>
              <span className='font-semibold text-black-700'>{selectedNonMappedOrders.length}</span>{' '}
              fund{selectedNonMappedOrders.length !== 1 ? 's' : ''} selected
            </p>
            <Button
              type='button'
              className='w-full sm:w-auto'
              onClick={() => setMapModalOpen(true)}
            >
              Map With Basket
            </Button>
          </div>
        </div>
      )}

      <Dialog
        open={mapModalOpen}
        onOpenChange={(open) => {
          if (!open) closeMapModal()
          else setMapModalOpen(true)
        }}
      >
        <DialogContent className='sm:max-w-xl font-DMSans' showclose={true}>
          <DialogHeader>
            <DialogTitle>Map orders to basket</DialogTitle>
            <DialogDescription>
              Choose a basket to assign the selected non-mapped orders.
            </DialogDescription>
          </DialogHeader>

          <div className='space-y-4'>
            <div className='space-y-2'>
              <Label htmlFor='map-basket-select'>Basket</Label>
              {basketSelectOptions.length > 0 ? (
                <Select
                  value={selectedBasketInvestmentId || undefined}
                  onValueChange={setSelectedBasketInvestmentId}
                  disabled={mapSubmitting}
                >
                  <SelectTrigger id='map-basket-select' className='w-full border'>
                    <SelectValue placeholder='Select basket' />
                  </SelectTrigger>
                  <SelectContent className="z-[99999999]">
                    {basketSelectOptions.map((b) => (
                      <SelectItem
                        key={String(b.customerBasketInvestmentId)}
                        value={String(b.customerBasketInvestmentId)}
                      >
                        {b.customerBasketName}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <p className='text-sm text-black-400'>
                  No baskets found for this client. Basket holdings must exist before you can map
                  orders.
                </p>
              )}
            </div>

            {selectedBasketInvestmentId ? (
              <div className='space-y-4'>
                <div className='rounded-xl border border-[#D3DBEC] bg-white p-4'>
                  <p className='mb-1 text-sm font-semibold text-black-700'>Funds in this basket</p>
                  {selectedBasketName ? (
                    <p className='mb-3 text-xs text-black-400'>{selectedBasketName}</p>
                  ) : null}
                  {selectedBasketHoldings.length > 0 ? (
                    <ul className='max-h-44 space-y-3 overflow-y-auto text-sm'>
                      {selectedBasketHoldings.map((holding, idx) => {
                        const currentVal =
                          Number(holding?.currentNav || 0) * Number(holding?.netUnits || 0)
                        return (
                          <li
                            key={`${holding?.bseSchemeCode || idx}-${idx}`}
                            className='flex gap-2 border-b border-[#D3DBEC]/60 pb-3 last:border-0 last:pb-0'
                          >
                            <img
                              src={`${env.MF_LOGOS_URL}/${holding?.amcCode}.png`}
                              alt=''
                              className='h-9 w-9 shrink-0 rounded-md'
                            />
                            <div className='min-w-0 flex-1'>
                              <p className='font-medium leading-snug text-black-700'>
                                {holding?.legalName || holding?.schemeName || '-'}
                              </p>
                              <p className='mt-0.5 text-xs text-black-400'>
                                NAV ₹{toCurrency(holding?.currentNav)}
                                {holding?.netUnits != null
                                  ? ` · ${toCurrency(holding.netUnits)} units`
                                  : ''}
                              </p>
                              <div className='mt-1 flex flex-wrap gap-x-3 text-xs'>
                                <span className='text-black-500'>
                                  Invested{' '}
                                  <span className='font-semibold text-black-600'>
                                    ₹ {toCurrency(Number(holding?.netInvestedAmount || 0))}
                                  </span>
                                </span>
                                <span className='text-black-500'>
                                  Current{' '}
                                  <span className='font-semibold text-black-600'>
                                    ₹ {toCurrency(currentVal)}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  ) : (
                    <p className='text-sm text-black-400'>No fund rows found for this basket.</p>
                  )}
                </div>

                <div className='rounded-xl border border-[#D3DBEC] bg-[#F4F7FE] p-4'>
                  <p className='mb-2 text-sm font-semibold text-black-700'>
                    Selected non-mapped orders
                  </p>
                  <ul className='max-h-44 space-y-2 overflow-y-auto text-sm'>
                    {getSelectedNonMappedOrderObjects().map((order, idx) => (
                      <li
                        key={`${order?.orderNumber}-${idx}`}
                        className='flex justify-between gap-2 border-b border-[#D3DBEC]/60 pb-2 last:border-0 last:pb-0'
                      >
                        <span className='min-w-0 flex-1 text-black-600'>
                          {order?.legalName || order?.schemeName || '-'}
                        </span>
                        <span className='shrink-0 text-black-500'>
                          ₹ {toCurrency(Number(order?.allotedAmt || 0))}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <p className='mt-3 text-xs text-black-400'>
                    Order numbers:{' '}
                    {getSelectedNonMappedOrderObjects()
                      .map((o) => o?.orderNumber)
                      .filter(Boolean)
                      .join(', ')}
                  </p>
                </div>
              </div>
            ) : null}
          </div>

          <DialogFooter className='gap-2 sm:gap-0'>
            <Button type='button' variant='outline' onClick={closeMapModal} disabled={mapSubmitting}>
              Close
            </Button>
            <Button
              type='button'
              onClick={handleAssignOrdersToBasket}
              disabled={
                mapSubmitting ||
                !selectedBasketInvestmentId ||
                basketSelectOptions.length === 0 ||
                getSelectedNonMappedOrderObjects().length === 0
              }
              className="data-[disabled]:bg-primary-300 data-[disabled]:text-white data-[disabled]:cursor-not-allowed"
            >
              {mapSubmitting ? (
                <>
                  <Loader2 className='mr-2 h-4 w-4 animate-spin' />
                  Mapping…
                </>
              ) : (
                'Map orders'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog
        open={shuffleModalOpen}
        onOpenChange={(open) => {
          if (!open) closeShuffleModal()
          else setShuffleModalOpen(true)
        }}
      >
        <DialogContent className='sm:max-w-xl font-DMSans' showclose={true}>
          <DialogHeader>
            <DialogTitle>Shuffle fund to another basket</DialogTitle>
            <DialogDescription>
              Select a basket and move this fund from the current basket.
            </DialogDescription>
          </DialogHeader>

          <div className='space-y-4'>
            {selectedShuffleFund ? (
              <div className='rounded-xl border border-[#D3DBEC] bg-[#F4F7FE] p-4'>
                <p className='mb-1 text-sm font-semibold text-black-700'>New fund you want to add</p>
                <div className='mt-2 flex items-start gap-3'>
                  <img
                    src={`${env.MF_LOGOS_URL}/${selectedShuffleFund?.amcCode}.png`}
                    alt={selectedShuffleFund?.amcCode || 'amc-logo'}
                    className='h-10 w-10 shrink-0 rounded-md'
                  />
                  <div className='min-w-0'>
                    <p className='text-sm text-black-600'>
                      {selectedShuffleFund?.legalName || selectedShuffleFund?.schemeName || '-'}
                    </p>
                    <p className='mt-1 text-xs text-black-400'>
                      Scheme Code: {selectedShuffleFund?.bseSchemeCode || '-'}
                    </p>
                  </div>
                </div>
              </div>
            ) : null}

            <div className='space-y-2'>
              <Label htmlFor='shuffle-basket-select'>Select basket</Label>
              {shuffleBasketOptions.length > 0 ? (
                <Select
                  value={selectedShuffleBasketInvestmentId || undefined}
                  onValueChange={setSelectedShuffleBasketInvestmentId}
                  disabled={shuffleSubmitting}
                >
                  <SelectTrigger id='shuffle-basket-select' className='w-full border'>
                    <SelectValue placeholder='Select target basket' />
                  </SelectTrigger>
                  <SelectContent className='z-[99999999]'>
                    {shuffleBasketOptions.map((b) => (
                      <SelectItem
                        key={String(b.customerBasketInvestmentId)}
                        value={String(b.customerBasketInvestmentId)}
                      >
                        {b.customerBasketName}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <p className='text-sm text-black-400'>
                  No other baskets available for this client.
                </p>
              )}
            </div>

            {selectedShuffleBasketInvestmentId ? (
              <div className='rounded-xl border border-[#D3DBEC] bg-white p-4'>
                <p className='mb-1 text-sm font-semibold text-black-700'>Funds in selected basket</p>
                {selectedShuffleBasketName ? (
                  <p className='mb-3 text-xs text-black-400'>{selectedShuffleBasketName}</p>
                ) : null}
                {selectedShuffleBasketHoldings.length > 0 ? (
                  <ul className='max-h-44 space-y-3 overflow-y-auto text-sm'>
                    {selectedShuffleBasketHoldings.map((holding, idx) => (
                      <li
                        key={`${holding?.bseSchemeCode || idx}-${idx}`}
                        className='flex items-start gap-3 border-b border-[#D3DBEC]/60 pb-2 last:border-0 last:pb-0'
                      >
                        <img
                          src={`${env.MF_LOGOS_URL}/${holding?.amcCode}.png`}
                          alt={holding?.amcCode || 'amc-logo'}
                          className='h-9 w-9 shrink-0 rounded-md'
                        />
                        <div className='min-w-0'>
                          <p className='font-medium text-black-700'>
                            {holding?.legalName || holding?.schemeName || '-'}
                          </p>
                          <p className='text-xs text-black-400'>Code: {holding?.bseSchemeCode || '-'}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className='text-sm text-black-400'>No funds in selected basket.</p>
                )}
              </div>
            ) : null}
          </div>

          <DialogFooter className='gap-2 sm:gap-0'>
            <Button
              type='button'
              variant='outline'
              onClick={closeShuffleModal}
              disabled={shuffleSubmitting}
            >
              Close
            </Button>
            <Button
              type='button'
              onClick={handleShuffleFund}
              disabled={
                shuffleSubmitting ||
                !selectedShuffleFund?.bseSchemeCode ||
                !selectedShuffleFund?.customerBasketInvestmentId ||
                !selectedShuffleBasketInvestmentId ||
                shuffleBasketOptions.length === 0
              }
              className='data-[disabled]:bg-primary-300 data-[disabled]:text-white data-[disabled]:cursor-not-allowed'
            >
              {shuffleSubmitting ? (
                <>
                  <Loader2 className='mr-2 h-4 w-4 animate-spin' />
                  Moving...
                </>
              ) : (
                'Move'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export const Boilerplate = ({ state, desc }) => {
  return (
    <div className='h-3/5 flex items-center justify-center p-4'>
      <Card className='w-full max-w-sm text-center border-none shadow-none'>
        <CardHeader>
          <img className='h-14 w-14' src={`${env.SVGS}/error-icon.svg`} alt='Error-Icon' />
          <div className='w-20 h-20 mx-auto mb-4 flex justify-center items-center'>
            <img src={`${env.SVGS}/error-icon.svg`} />
          </div>
          <CardTitle className='text-xl'>{state}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className='text-muted-foreground mb-6'>{desc}</p>
        </CardContent>
      </Card>
    </div>
  )
}

export default UserBasketHoldings
